import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryAppMetricsRequestParamsDto {
    appIds: string[];
    startTime?: string;
    endTime: string;
    granularity?: CubeTimeDimensionGranularity;
}